import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SearchOfferItemComponent = ({ item, onToggleSelectItem }) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell size={'small'}>
        <Checkbox
          id={`offerDetail_selected${item.assetId}`}
          checked={item.selected || false}
          onChange={() => onToggleSelectItem(item.assetId)}
        />
      </TableCell>
      <TableCell>{item.chassisNumber || '-'}</TableCell>
      <TableCell>{item.brandName || '-'}</TableCell>
      <TableCell>{item.modelName || '-'}</TableCell>
      <TableCell>
        {item.purchasePrice
          ? t('Offer.Edit.OfferDetail.Price', {
              amount: t('DECIMAL2', { number: item.purchasePrice }),
              currency: item.currencyCode
            })
          : '-'}
      </TableCell>
    </TableRow>
  );
};

SearchOfferItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired
};

export default SearchOfferItemComponent;
